module.exports = __webpack_public_path__ + "static/media/wheel.607d7ae7.svg";